<template>
  <wp-items-view
    content-type="research-articles"
    content-type-singular="research-article"
    content-name="Research articles"
    content-name-singular="Research article"
  />
</template>

<script>
import WpItemsView from '@/views/wp-item/wp-items-view/WpItemsView.vue'

export default {
  components: {
    WpItemsView,
  },
}
</script>

<style scoped>

</style>
